import './show_error.less';

import React from 'react';

export default class ShowError extends React.Component{
  constructor(props){
    super(props);
  }

  render(){
    const {state, props} = this;
    const {errorMessage} = props;

    return(
      <div className = "error-wrap">
        <p className = "error-message"><span className="icon-lightning"></span>{errorMessage}</p>
      </div>
    );
  }
}

ShowError.propTypes = {
  errorMessage: React.PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// app/components/error/show_error.jsx